import { put, fork, call, takeEvery, all, select } from 'redux-saga/effects';
import app from '../../app';
import { strLength } from '../../utils/string';
import {
  loadNewFeedbackActInfoCompletion,
  checkNewFeedbackLimitCompletion,
  editNewFeedbackCompletion,
  loadNewFeedbackListCompletion,
  loadOwnNewFeedbackInfoCompletion,
  loadNewFeedbackDetailCompletion,
  catchError,
} from '../../actions';

export function* watchLoadNewFeedbackActInfo() {
  yield takeEvery('LOAD_NEW_FEEDBACK_ACT_INFO', function*({ actId }) {
    const options = {
      url: `/api/pc/${actId}`,
    };
    const result = yield call(app.httpFetch, options);
    yield put(loadNewFeedbackActInfoCompletion(result.error, result.data));
  });
}

export function* watchCheckNewFeedbackLimit() {
  yield takeEvery('CHECK_NEW_FEEDBACK_LIMIT', function*({ actId }) {
    const options = {
      url: `/api/pc/check/${actId}`,
    };
    const result = yield call(app.httpFetch, options);
    yield put(checkNewFeedbackLimitCompletion(result.error, result.data));
  });
}

export function* watchEditNewFeedback() {
  yield takeEvery('EDIT_NEW_FEEDBACK', function*({ id, actId }) {
    const feedbackEdit = yield select(state => state.activity.newFeedback.edit);
    const {
      input: { images, content },
    } = feedbackEdit;

    let error;
    const submitContent = content.trim();
    if (!submitContent) {
      error = new Error('还没填写使用感受哦');
    }
    if (strLength(submitContent) < 30) {
      error = new Error('使用感受不少于30字');
    }
    if (strLength(submitContent) > 800) {
      error = new Error('使用感受不超过800字');
    }
    if (images.length < 1) {
      error = new Error('请至少上传1张图片');
    }

    if (error) {
      yield put(catchError(error));
      yield put(editNewFeedbackCompletion(error));
      return;
    }

    const options = {
      url: '/api/pcFeedback/save',
      method: 'POST',
      data: { id, actId, images, content: submitContent },
    };

    const result = yield call(app.httpFetch, options);
    yield put(editNewFeedbackCompletion(actId, result.error, result.data));
  });
}

export function* watchLoadNewFeedbackList() {
  yield takeEvery('LOAD_NEW_FEEDBACK_LIST', function*({
    actId,
    show,
    willReload,
  }) {
    const { list, query } = yield select(
      state => state.activity.newFeedback.master
    );
    let start = 0;

    if (!willReload && list) {
      start = list.length;
    }

    const options = {
      url: `/api/pcFeedback/list?actId=${actId}&show=${show}&start=${start}&size=${query.size}`,
    };

    const result = yield call(app.httpFetch, options);
    yield put(
      loadNewFeedbackListCompletion(
        result.error,
        (result.data && result.data.listData) || []
      )
    );
  });
}

export function* watchLoadOwnNewFeedbackInfo() {
  yield takeEvery('LOAD_OWN_NEW_FEEDBACK_INFO', function*({ actId }) {
    const options = {
      url: `/api/pcFeedback/${actId}`,
    };
    const result = yield call(app.httpFetch, options);
    yield put(loadOwnNewFeedbackInfoCompletion(result.error, result.data));
  });
}

export function* watchLoadNewFeedbackDetail() {
  yield takeEvery('LOAD_NEW_FEEDBACK_DETAIL', function*({ id }) {
    const options = {
      url: `/api/pcFeedback/get/${id}`,
    };
    const result = yield call(app.httpFetch, options);
    yield put(loadNewFeedbackDetailCompletion(id, result.error, result.data));
  });
}

export default function* newFeedbackSaga() {
  yield all([
    fork(watchLoadNewFeedbackActInfo),
    fork(watchCheckNewFeedbackLimit),
    fork(watchEditNewFeedback),
    fork(watchLoadNewFeedbackList),
    fork(watchLoadOwnNewFeedbackInfo),
    fork(watchLoadNewFeedbackDetail),
  ]);
}
